import BusinessIcon from '@mui/icons-material/Business';
import PeopleIcon from '@mui/icons-material/People';
import CableIcon from '@mui/icons-material/Cable';
import { PATH_ADMIN } from 'src/routes/paths';
import I18n from 'src/i18n/index';

// ----------------------------------------------------------------------

const adminSidebarConfig = () => [
  {
    subheader: I18n.t('admin.sidebar.management'),
    items: [
      {
        title: I18n.t('admin.sidebar.workspaces'),
        path: PATH_ADMIN.workspaces,
        icon: <BusinessIcon />,
      },
      {
        title: I18n.t('admin.sidebar.users'),
        path: PATH_ADMIN.users,
        icon: <PeopleIcon />,
      },
      {
        title: I18n.t('admin.sidebar.integrations'),
        path: PATH_ADMIN.integrations,
        icon: <CableIcon />,
      },
    ],
  },
];

export default adminSidebarConfig;
